import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TomoCovers } from './TomoCovers';
import { tomos } from '../data/megaPack';
import { useIsMobile } from '../hooks/useMediaQuery';
export function Tomos() {
  const isMobile = useIsMobile();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [featured, ...rest] = tomos;
  return <section className="bg-cream-100 py-10 sm:py-20" aria-labelledby="los-7-tomos" data-id="element-286" data-mp="1m25v7ufwtezc">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-287" data-mp="1m4jpw26ogp6d">
        <SectionHeading eyebrow="Contenido completo" title="Los 7 tomos" subtitle="Tu biblioteca para acompañar, compartir y dejar de improvisar." data-id="element-288" data-mp="200x85dj1culw" />

        <TomoCovers data-id="element-289" data-mp="5n5rhu2ahagy" />

        {isMobile ?
      // Móvil: 7 ítems compactos; se toca uno y se abre su detalle
      <ul className="mt-6 space-y-2" data-id="element-290" data-mp="1nnerlkmg5p7">
            {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <li key={tomo.code} className={['overflow-hidden rounded-2xl ring-1 transition-colors duration-150 ease-out', isOpen ? 'bg-teal-800 ring-teal-800' : 'bg-cream-50 ring-teal-900/8'].join(' ')} data-id="element-291" data-mp="39pjhjul6z0iq" data-mpi={index}>
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`tomo-panel-${index}`} className="flex w-full items-center gap-3 px-3.5 py-3 text-left" data-id="element-292" data-mp="3ogs4fvxpm7s6">
                    <span className={['flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-display text-[0.65rem] font-900', isOpen ? 'bg-gold-500 text-teal-900' : 'bg-teal-100 text-teal-800'].join(' ')} data-id="element-293" data-mp="231w2ye1zj82o">
                      {tomo.code}
                    </span>
                    <span className={['min-w-0 flex-1 font-display text-[0.8rem] font-800 uppercase leading-snug', isOpen ? 'text-cream-50' : 'text-teal-900'].join(' ')} data-id="element-294" data-mp="29ygvti9yju4m">
                      {tomo.title}
                    </span>
                    <ChevronDownIcon className={['h-4 w-4 shrink-0 transition-transform duration-200 ease-out', isOpen ? 'rotate-180 text-gold-400' : 'text-teal-600'].join(' ')} aria-hidden="true" data-id="element-295" data-mp="2ews5nt0964mu" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-296" data-mp="2xob920y6vkpe">
                    {isOpen ? <motion.div id={`tomo-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-297" data-mp="3h8s9tnez6wcn">
                        <div className="px-3.5 pb-3.5" data-id="element-298" data-mp="2xkj56dw8wxw9">
                          <p className="text-[0.8rem] leading-relaxed text-cream-100/85" data-id="element-299" data-mp="32bss36qetn4g">
                            {tomo.description}
                          </p>
                          <ul className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-300" data-mp="2omh5q2s5udb3">
                            {tomo.tags.map(tag => <li key={tag} className="rounded-full bg-cream-50/10 px-2.5 py-0.5 text-[0.7rem] text-cream-100/85 ring-1 ring-cream-50/20" data-id="element-301" data-mp="2emgp4oloebal">
                                {tag}
                              </li>)}
                          </ul>
                        </div>
                      </motion.div> : null}
                  </AnimatePresence>
                </li>;
        })}
          </ul> : <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-302" data-mp="385qawseht67i">
            <article className="flex flex-col rounded-2xl bg-teal-800 p-7 text-cream-50 shadow-lift lg:row-span-2" data-id="element-303" data-mp="339svcob203vs">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gold-500 font-display text-sm font-900 text-teal-900" data-id="element-304" data-mp="2z98zrp64p8br">
                {featured.code}
              </span>
              <h3 className="mt-5 font-display text-2xl font-800 uppercase leading-tight" data-id="element-305" data-mp="2pb1mpheynaf1">
                {featured.title}
              </h3>
              <p className="mt-3 text-[0.975rem] leading-relaxed text-cream-100/80" data-id="element-306" data-mp="nh27wm2mqaxl">
                {featured.description}
              </p>
              <ul className="mt-auto flex flex-wrap gap-2 pt-7" data-id="element-307" data-mp="uys44xks0ep3">
                {featured.tags.map(tag => <li key={tag} className="rounded-full bg-cream-50/10 px-3 py-1 text-xs text-cream-100/85 ring-1 ring-cream-50/20" data-id="element-308" data-mp="zxl73w2fsnb0">
                    {tag}
                  </li>)}
              </ul>
            </article>

            {rest.map(tomo => <article key={tomo.code} className="flex flex-col rounded-2xl bg-cream-50 p-6 shadow-card ring-1 ring-teal-900/5 transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-309" data-mp="h0a8mdompxwm">
                <div className="flex items-start gap-3" data-id="element-310" data-mp="r0kne2qbbddw">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 font-display text-xs font-900 text-teal-800" data-id="element-311" data-mp="1xg4pkrvmkvio">
                    {tomo.code}
                  </span>
                  <h3 className="font-display text-base font-800 uppercase leading-snug text-teal-900" data-id="element-312" data-mp="2b42tj8p3n7u">
                    {tomo.title}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-clay" data-id="element-313" data-mp="bdd73rddekcs">
                  {tomo.description}
                </p>
                <ul className="mt-auto flex flex-wrap gap-1.5 pt-5" data-id="element-314" data-mp="7ckxgx0l6dfz">
                  {tomo.tags.map(tag => <li key={tag} className="rounded-full bg-teal-50 px-2.5 py-1 text-xs text-teal-700 ring-1 ring-teal-700/10" data-id="element-315" data-mp="3frbe4efmac4z">
                      {tag}
                    </li>)}
                </ul>
              </article>)}
          </div>}
      </div>
    </section>;
}